<template>
  <div class="py-md-5 py-4">
    <div class="text-center mb-5">
      <h3>Register Account</h3>
      <p class="text-muted">Create your NEW ABC Account.</p>
    </div>
    <form class="needs-validation" novalidate action="index.html">
      <div class="form-floating mb-3">
        <input
          type="email"
          class="form-control"
          id="floatingInput"
          v-model="email"
          placeholder="name@example.com"
        />
        <label for="floatingInput">
          <span :class="emailIsCorrect ? 'has_required' : ''"
            >E-Mail address</span
          >
        </label>
        <div class="invalid-feedback">Please Enter Email</div>
      </div>

      <div class="mb-3 form-floating">
        <input
          type="text"
          class="form-control"
          id="floatingInput"
          placeholder="Joud"
          aria-describedby="username"
          v-model="username"
        />
        <label for="floatingInput">
          <span :class="nameIsCorrect ? 'has_required' : ''">Username</span>
        </label>
        <div class="form-text">Username must be in lowercase letters only</div>
        <div class="invalid-feedback">Please Enter Username</div>
      </div>

      <div class="form-floating mb-3">
        <select
          id="floatingSelect"
          class="form-select"
          v-model="roles"
          aria-label="Default select example"
        >
          <option value="manager">Practitioners</option>
          <option value="guest">Youth</option>
        </select>
        <label for="floatingSelect" class="form-label"
          >You are registering as:</label
        >
      </div>

      <div class="mb-3">
        <div class="form-floating position-relative auth-pass-inputgroup mb-3">
          <input
            type="password"
            class="form-control pe-5"
            placeholder="Password"
            id="password"
            v-model="password"
            required
          />
          <label for="password" class="form-label">Password</label>
          <button
            class="btn mt-2 btn-link position-absolute end-0 top-0 text-decoration-none"
            type="button"
            @click="$store.state.utils.switTypeInput"
          >
            <i class="ri-eye-fill align-middle"></i>
          </button>
        </div>
        <div class="form-text font-size-12 mx-1 row">
          <div
            :class="
              has_lowercsae
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one lowercase letter"
          ></div>
          <div
            :class="
              has_uppercase
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one uppercase letter"
          ></div>
          <div
            :class="
              has_number
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one Number"
          ></div>
          <div
            :class="
              has_minimum_lenth
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least 8 chacters"
          ></div>
          <div
            :class="
              has_special
                ? 'has_required text-white p-1 bg-primary col'
                : 'p-1 col bg-light'
            "
            title="At least one special character"
          ></div>
        </div>
      </div>
      <div class="form-floating mb-3">
        <input
          type="password"
          class="form-control"
          id="replaypassword"
          placeholder="Password"
          v-model="replaypassword"
        />
        <label for="replaypassword" class="form-label">Repeat password</label>
        <div class="invalid-feedback">Please Enter Password</div>
        <span
          :class="
            password === replaypassword && password.length > 7
              ? 'has_required'
              : ''
          "
        >
          password is matching
        </span>
      </div>
      <div class="form-check mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          ref="isAgree"
          id="flexCheckDefault"
        />
        <label class="form-check-label small" for="flexCheckDefault">
          <span>By registering you agree to the NEW ABC APP</span>
          <router-link
            :to="{ name: 'CookiesPolicy' }"
            custom
            v-slot="{ navigate }"
          >
            <a
              role="link"
              title="Go to Cookies Policy site"
              class="text-primary ps-2"
              @click="navigate"
              @keypress.enter="navigate"
            >
              Terms of Use
            </a>
          </router-link>
        </label>
      </div>
      <div class="mb-3">
        <button
          v-if="
            passwordIsCorrect &&
            password === replaypassword &&
            nameIsCorrect &&
            emailIsCorrect
          "
          type="submit"
          class="btn btn-primary w-100 waves-effect waves-light"
          @click="singUp"
        >
          Sign Up
        </button>
        <button
          v-else
          type="submit"
          class="btn btn-primary w-100 waves-effect waves-light disabled"
          disabled
        >
          Sign Up
        </button>
      </div>
    </form>
    <!-- end form -->

    <div class="mt-5 text-center text-muted">
      <p>
        Already have an account?
        <router-link :to="{ name: 'Signin' }" custom v-slot="{ navigate }">
          <a
            role="link"
            @click="navigate"
            class="fw-medium text-decoration-underline"
            @keypress.enter="navigate"
          >
            Log in
          </a>
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignUp",

  data() {
    return {
      password: "",
      replaypassword: "",
      username: "",
      roles: "guest",
      email: "",

      has_minimum_lenth: false,
      has_number: false,
      has_lowercsae: false,
      has_uppercase: false,
      has_special: false,

      passwordIsCorrect: false,
      nameIsCorrect: false,
      emailIsCorrect: false,
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },

  watch: {
    password() {
      const val = this.$store.state.utils.filters.password(this.password);

      this.has_minimum_lenth = val.has_minimum_lenth;
      this.has_number = val.has_number;
      this.has_lowercsae = val.has_lowercsae;
      this.has_uppercase = val.has_uppercase;
      this.has_special = val.has_special;

      this.passwordIsCorrect =
        this.has_special &&
        this.has_uppercase &&
        this.has_lowercsae &&
        this.has_number &&
        this.has_minimum_lenth;
    },

    username() {
      const val = this.$store.state.utils.filters.name(this.username);

      this.nameIsCorrect =
        val.has_minimum_lenth && val.only_letters && val.is_mail;
    },

    email() {
      const val = this.$store.state.utils.filters.validateEmail(this.email);

      this.emailIsCorrect = val;
    },
  },

  methods: {
    singUp() {
      event.preventDefault();
      if (!this.$refs.isAgree.checked) {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Please agree to the NEW ABC APP Terms of Use!",
          },
          2500
        );
        return;
      }
      if (
        this.passwordIsCorrect &&
        this.password === this.replaypassword &&
        this.nameIsCorrect &&
        this.emailIsCorrect
      ) {
        const data = {
          username: this.username,
          email: this.email,
          password: this.password,
          roles: this.roles,
        };

        this.$store.state.modules.api.singUp(data).then((resp) => {
          this.username = "";
          this.email = "";
          this.password = "";
          this.replaypassword = "";
          if (resp.status == 200) {
            this.$store.state.modules.account.user = resp.data.user;
            this.$store.state.modules.account.token = resp.data.token;
            this.$router.push({ name: "Home" });
          } else {
            this.$store.state.utils.setNewNotifications(
              {
                type: "warning",
                message: "Check the entries are correct",
              },
              2500
            );
          }
        });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Check the entries are correct",
          },
          2500
        );
      }
    },
  },
};
</script>
